import React, { useState, useEffect } from "react";
import styles from "./FilterSheet.module.css";

export default function FilterSheet({ filters: initialFilters, onClose, onApply, onClear }) {
  const [filters, setFilters] = useState(
    initialFilters || {
      minPrice: "",
      maxPrice: "",
      bedrooms: "",
      bathrooms: "",
      minSqft: "",
      maxSqft: "",
      tags: [],
      utils: [],
      customTag: "",
    }
  );

  // ✅ Keep state in sync when filters from HomePage change
  useEffect(() => {
    setFilters(
      initialFilters || {
        minPrice: "",
        maxPrice: "",
        bedrooms: "",
        bathrooms: "",
        minSqft: "",
        maxSqft: "",
        tags: [],
        utils: [],
        customTag: "",
      }
    );
  }, [initialFilters]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      ["minPrice", "maxPrice", "bedrooms", "bathrooms", "minSqft", "maxSqft"].includes(name)
    ) {
      if (value === "" || /^[0-9\b]+$/.test(value)) {
        setFilters((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFilters((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleTagChange = (e) => {
    const { value, checked } = e.target;
    setFilters((prev) => {
      if (checked) return { ...prev, tags: [...prev.tags, value] };
      return { ...prev, tags: prev.tags.filter((t) => t !== value) };
    });
  };

  const handleCustomTag = (e) => {
    setFilters((prev) => ({ ...prev, customTag: e.target.value }));
  };

  const handleApply = () => {
    onApply(filters);
    onClose();
  };

  const handleClear = () => {
    const cleared = {
      minPrice: "",
      maxPrice: "",
      bedrooms: "",
      bathrooms: "",
      minSqft: "",
      maxSqft: "",
      tags: [],
      utils: [],
      customTag: "",
    };
    setFilters(cleared);
    onClear();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>Filters</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Content */}
        <div className={styles.content}>
          {/* --- Price Range --- */}
          <label className={styles.label}>Price Range</label>
          <div className={styles.priceRange}>
            <input
              type="text"
              name="minPrice"
              placeholder="Min"
              value={filters.minPrice}
              onChange={handleChange}
            />
            <span>-</span>
            <input
              type="text"
              name="maxPrice"
              placeholder="Max"
              value={filters.maxPrice}
              onChange={handleChange}
            />
          </div>

          {/* --- Square Feet --- */}
          <label className={styles.label}>Square Feet</label>
          <div className={styles.priceRange}>
            <input
              type="text"
              name="minSqft"
              placeholder="Min"
              value={filters.minSqft}
              onChange={handleChange}
            />
            <span>-</span>
            <input
              type="text"
              name="maxSqft"
              placeholder="Max"
              value={filters.maxSqft}
              onChange={handleChange}
            />
          </div>

          {/* --- Bedrooms --- */}
          <label className={styles.label}>Bedrooms</label>
          <input
            type="text"
            name="bedrooms"
            placeholder="e.g. 2"
            value={filters.bedrooms}
            onChange={handleChange}
          />

          {/* --- Bathrooms --- */}
          <label className={styles.label}>Bathrooms</label>
          <input
            type="text"
            name="bathrooms"
            placeholder="e.g. 1"
            value={filters.bathrooms}
            onChange={handleChange}
          />

          {/* --- Amenities --- */}
          <label className={styles.label}>Utilities / Amenities</label>
          <div className={styles.tags}>
            {[
              "Water",
              "Gas",
              "Electricity",
              "Parking",
              "Laundry",
              "Trash Collection",
            ].map((u) => (
              <label key={u} className={styles.tagOption}>
                <input
                  type="checkbox"
                  value={u}
                  checked={filters.utils?.includes(u)}
                  onChange={(e) => {
                    const { value, checked } = e.target;
                    setFilters((prev) => ({
                      ...prev,
                      utils: checked
                        ? [...(prev.utils || []), value]
                        : (prev.utils || []).filter((x) => x !== value),
                    }));
                  }}
                />
                {u}
              </label>
            ))}
          </div>

          {/* --- Custom Tag --- */}
          <input
            type="text"
            placeholder="Add tags comma separated..."
            value={filters.customTag}
            onChange={handleCustomTag}
          />
        </div>

        {/* Buttons */}
        <div className={styles.actions}>
          <button className={styles.clearBtn} onClick={handleClear}>
            Clear All
          </button>
          <button className={styles.applyBtn} onClick={handleApply}>
            See Results
          </button>
        </div>
      </div>
    </div>
  );
}

